import Carousel from '@/atoms/Carousel/Carousel'
import CaseStudyCard from '@/molecules/CaseStudyCard/CaseStudyCard'
import React, { Fragment } from 'react'

interface Props {
  featured: CaseStudy[]
  title?: string
  indicatorSize?: 'sm' | 'lg'
}

function CaseStudyCarousel({
  featured,
  title,
  indicatorSize
}: Props): JSX.Element {
  return (
    <section className="mt-8 mb-12 lg:mt-12 lg:mb-16 mx-auto">
      {featured.length > 0 && (
        <Fragment>
          <h2 className="max-width-container h4 font-medium text-center  |  mb-6">
            {title}
          </h2>
          <div className="md:space-y-36 overflow-x-hidden">
            <Carousel
              className="mx-auto"
              indicatorSize={indicatorSize ? indicatorSize : 'lg'}
              slides={featured.map((caseStudy, index) => (
                <div
                  className="max-width-container  |  mt-8 mb-12 lg:mt-12 lg:mb-16"
                  key={caseStudy.id}
                >
                  <CaseStudyCard
                    data={caseStudy}
                    isFeatured
                    isInverted={index % 2 === 1}
                    preventRedirection={true}
                  />
                </div>
              ))}
            />
          </div>
        </Fragment>
      )}
    </section>
  )
}

export default CaseStudyCarousel
